// 日本地図の共通プロジェクション定数
// japan_map_controller.js, dot_map_controller.js, generate_japan_map_paths.mjs で共有

export const MAP_WIDTH = 600
export const MAP_HEIGHT = 680

export const MAINLAND_CENTER = [137, 37]
export const MAINLAND_SCALE = 1680

export const OKINAWA_CENTER = [127.6, 26.5]
